export default "__VITE_ASSET__Ce8cIc8F__"